<template>
    <!-- JS-driven floating label porque CSS :placeholder-shown no funciona en <select> -->
    <div class="tw:relative tw:w-full">
        <select
            ref="selectRef"
            class="tw:block tw:px-3 tw:py-3 tw:w-full tw:text-sm tw:rounded-xl tw:border tw:border-slate-200 tw:bg-white tw:text-slate-900 tw:outline-none tw:transition tw:cursor-pointer focus:tw:border-blue-400 focus:tw:ring-2 focus:tw:ring-blue-100"
            v-bind="$attrs"
            @change="onChange"
        >
            <option value="">{{ placeholder }}</option>
            <option v-for="opt in options" :key="opt.value || opt.id" :value="opt.value || opt.id">
                {{ opt.label || opt.name || opt }}
            </option>
        </select>
        <span
            v-if="label"
            class="tw:absolute tw:uppercase tw:duration-300 tw:z-10 tw:pointer-events-none tw:tracking-wide tw:origin-left tw:bg-white tw:px-2"
            :class="hasValue
                ? 'tw:start-2 tw:top-3 tw:-translate-y-[1.35rem] tw:scale-75 tw:font-bold tw:text-blue-500'
                : 'tw:start-3 tw:top-1/2 tw:-translate-y-1/2 tw:scale-100 tw:font-normal tw:text-slate-400'"
        >
            {{ label }}
        </span>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    defineProps({
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        options: { type: Array, default: () => [] }
    });

    const selectRef = ref(null);
    const hasValue = ref(false);

    const onChange = () => {
        hasValue.value = !!selectRef.value?.value;
    };
</script>

<script>
    export default { inheritAttrs: false };
</script>
